import {
    TextField,
    Button,
    MenuItem,
    Box,
    Card,
    CardContent,
    Grid,
    Checkbox,
    FormControlLabel,
    Snackbar,
    Alert,
    Collapse,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useRef } from "react";


import { useState, useEffect } from "react";
import StoreSelector from "./StoreSelector";
import Logo from "./logo.png";
import CaptchaBG from "./captcha-bg.jpg";
import RefreshIcon from "@mui/icons-material/Refresh";
import "./CustomerForm.css";

function CustomerForm() {

    const getDistinctColor = (index) => {
        const hue = (index * 137.508) % 360; // golden angle
        return `hsl(${hue}, 65%, 45%)`;
    };

    const { storeSlug } = useParams();
    const [storeNotFound, setStoreNotFound] = useState(false);
    const [loadingStore, setLoadingStore] = useState(true);

    const [marital, setMarital] = useState("single");

    const captchaInputRef = useRef(null);

    // captcha state
    // const [captcha, setCaptcha] = useState({ key: "", image_url: "" });
    // const [captchaValue, setCaptchaValue] = useState("");

    // Store
    const [selectedStore, setSelectedStore] = useState(null);

    // refer options
    const [referOptions, setReferOptions] = useState([]);
    const [referValue, setReferValue] = useState("");

    const [mobileError, setMobileError] = useState(false);
    const [whatsappError, setWhatsappError] = useState(false);

    const [toast, setToast] = useState({
        open: false,
        message: "",
        severity: "error",
    });

    const [existingUser, setExistingUser] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [checking, setChecking] = useState(false);

    const [captchaError, setCaptchaError] = useState(false);

    const [todayCount, setTodayCount] = useState(null);

    const fetchTodayCount = () => {
        if (!selectedStore?.id) return; // safety guard
        // fetch("https://hamarachoiceschemes.com/api/customer-survey/today-count/" + `?store=${selectedStore.id}`)
        fetch("https://test.hamarachoiceschemes.com/api/customer-survey/today-count" + `?store=${selectedStore.id}`)
        // fetch("http://localhost:8000/api/customer-survey/today-count/" + `?store=${selectedStore.id}`)
            .then(res => res.json())
            .then(data => setTodayCount(data.total_count))
            .catch(err => console.error("Count API error", err));
    };

    useEffect(() => {
        fetchTodayCount();
    }, []);

    // WhatsApp & Birthday state
    const [mobileValue, setMobileValue] = useState("");
    const [whatsappValue, setWhatsappValue] = useState("");
    const [autoFillWhatsApp, setAutoFillWhatsApp] = useState(false);
    const [birthdayDay, setBirthdayDay] = useState("");
    const [birthdayMonth, setBirthdayMonth] = useState("");
    const [anniversaryDay, setAnniversaryDay] = useState("");
    const [anniversaryMonth, setAnniversaryMonth] = useState("");
    const birthday_mmyy =
        birthdayMonth && birthdayDay
            ? `${String(birthdayDay).padStart(2, "0")}/${String(birthdayMonth).padStart(2, "0")}`
            : "";

    const anniversary_mmyy =
        anniversaryMonth && anniversaryDay
            ? `${String(anniversaryDay).padStart(2, "0")}/${String(anniversaryMonth).padStart(2, "0")}`
            : "";

    const referColorOptions = {
        bni: { bg: "#ffffff", color: "#ff0000" },
        direct: { bg: "#add8e6", color: "#000" },
        marketing: { bg: "#828282", color: "#fff" },
        calling: { bg: "#4caf50", color: "#ffeb3b" },
        "social media": { bg: "#ffeb3b", color: "#ff0000" },
    };

    // fallback (important for new backend values)
    const defaultStyle = { bg: "#eeeeee", color: "#000" };
    
    useEffect(() => {
        if (!storeSlug) return;

        setLoadingStore(true);
        setStoreNotFound(false);

        // fetch(`https://hamarachoiceschemes.com/api/store/${storeSlug}/`)
        fetch(`https://test.hamarachoiceschemes.com/api/store/${storeSlug}/`)
        // fetch(`http://localhost:8000/api/store/${storeSlug}/`)
            .then(res => {
                if (!res.ok) throw new Error("Store not found");
                return res.json();
            })
            .then(data => {
                setSelectedStore(data);
                fetchTodayCount()
                setLoadingStore(false);
            })
            .catch(() => {
                setStoreNotFound(true);
                setLoadingStore(false);
            });
    }, [storeSlug]);


    useEffect(() => {
        // fetchCaptcha();
        // fetch("https://hamarachoiceschemes.com/api/refer-through/")
        fetch("https://test.hamarachoiceschemes.com/api/refer-through/")
        // fetch("http://localhost:8000/api/refer-through/")
        .then((res) => res.json())
        .then((data) => setReferOptions(data));
    }, []);

    // useEffect for autofill
    useEffect(() => {
        if (autoFillWhatsApp && mobileValue) {
            setWhatsappValue(mobileValue);
        }
    }, [mobileValue, autoFillWhatsApp]);

    const [captcha, setCaptcha] = useState("");
    const [captchaValue, setCaptchaValue] = useState("");

    const generateCaptcha = () => {
        const value = Math.floor(1000 + Math.random() * 9000).toString();
        console.log("New captcha:", value);
        setCaptcha(value);
        setCaptchaValue("");
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const submitForm = async (e) => {
        e.preventDefault();

        if (!referValue) {
            // alert("Please select Referred By");
            setToast({
                open: true,
                message: "Please select Referred By",
                severity: "warning",
            });
            return;
        }
        
        if (e.target.mobile.value.length < 10) {
            setToast({
                open: true,
                message: "Mobile number must be at least 10 digits",
                severity: "warning",
            });
            return;
        }

        // console.log('Existing User 2', existingUser)
        // if (existingUser){
        //     setToast({
        //         open: true,
        //         message: "Mobile Number already exists!",
        //         severity: "warning",
        //     });
        //     setOpenDialog(true)
        //     return;
        // }

        if (!captchaValue) {
            // alert("Please enter captcha");
            setCaptchaError(true);
            setToast({
                open: true,
                message: "Please enter Captcha",
                severity: "warning",
            });
            return;
        }

        if (captchaValue !== captcha) {
            // alert("Invalid captcha");
            setCaptchaError(true);
            setToast({
                open: true,
                message: "Invalid captcha",
                severity: "warning",
            });
            generateCaptcha();

            return;
        }

        // if (e.target.whatsapp.value && e.target.whatsapp.value.length < 10) {
        //     setToast({
        //         open: true,
        //         message: "WhatsApp number must be at least 10 digits",
        //         severity: "warning",
        //     });
        //     return;
        // }

        const data = {
            name: e.target.name.value,
            mobile: e.target.mobile.value,
            whatsapp: e.target.whatsapp.value,
            birthday_mmyy: birthday_mmyy,
            marital_status: marital,
            spouse_name: e.target.spouse?.value || "",
            anniversary_mmyy: anniversary_mmyy,
            refer_through: referValue.id,
            location: e.target.location.value,
            address: e.target.address.value,
            store: selectedStore?.id, // <--- store the selected store ID
            captcha_key: captcha.key,
            captcha_value: captchaValue,
        };

        // const res = await fetch("https://hamarachoiceschemes.com/api/customer-survey/", {
        const res = await fetch("https://test.hamarachoiceschemes.com/api/customer-survey/", {
        // const res = await fetch("http://localhost:8000/api/customer-survey/", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        });

        if (res.ok) {
            // alert("Saved successfully 🎉");
            setToast({
                open: true,
                title: `Thank You ${data.name}`,
                message: "Your data saved successfully 🎉",
                severity: "success",
            });

            // fetchCaptcha();
            e.target.reset();
            fetchTodayCount();   // 🔥 refresh count
            setMarital("single");
            setMobileValue("");
            setWhatsappValue("");
            setAutoFillWhatsApp(false);

            setBirthdayDay("");
            setBirthdayMonth("");
            setAnniversaryDay("");
            setAnniversaryMonth("");
            setReferValue("")
            generateCaptcha();
        } else {
            // alert("Error, please check captcha or fields!");
            setToast({
                open: true,
                message: "Error, please check captcha or fields!",
                severity: "warning",
            });
            // fetchCaptcha();
        }
    };

    const checkMobileExists = async (mobile) => {
        try {
            setChecking(true);

            // const res = await fetch(`https://hamarachoiceschemes.com/api/check-mobile?mobile=${mobile}`);
            const res = await fetch(`https://test.hamarachoiceschemes.com/api/check-mobile?mobile=${mobile}`);
            // const res = await fetch(`http://localhost:8000/api/check-mobile?mobile=${mobile}`);
            const data = await res.json();
            console.log(data)

            if (data.exists) {
                setExistingUser(data.user); // store user data
                setOpenDialog(true);
            } else {
                setExistingUser(null);
            }
        } catch (err) {
            console.error("Error checking mobile", err);
        } finally {
            setChecking(false);
        }
    };

    if (loadingStore) {
        return (
            <Box sx={{ textAlign: "center", mt: 10 }}>
                <Typography variant="h6">Loading store...</Typography>
            </Box>
        );
    }

    if (storeNotFound) {
        return (
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fdf6f0",
                }}
            >
                <Card sx={{ p: 4, maxWidth: 400, textAlign: "center" }}>
                    <Typography variant="h5" fontWeight={700} color="error">
                        Store Not Found
                    </Typography>

                    <Typography sx={{ mt: 2, mb: 3 }}>
                        The store link you used is invalid or no longer active.
                    </Typography>
                </Card>
            </Box>
        );
    }

    return (
        <Box className="page-bg">
            <Grid container justifyContent="center">
                <Grid>
                    <Card className="form-card">
                        <CardContent>
                            {/* Logo */}
                            <Box className="logo-box">
                                <img src={Logo} alt="Brand Logo" />
                            </Box>

                            {selectedStore && (
                                <Box
                                    sx={{
                                        textAlign: "center", // centers the inline-block child
                                        mb: 1,
                                        // px: 1
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: "100%",
                                            display: "inline-block", // 🔥 makes width fit content
                                            textAlign: "center",
                                            mb: 3,
                                            py: 1,
                                            borderRadius: 2,
                                            backgroundColor: "#efdd0c",
                                            boxShadow: 1,
                                        }}
                                    >
                                        {/* Main Heading */}
                                        <Typography
                                            variant="h6"
                                            component="h4"
                                            sx={{
                                                fontWeight: 900,
                                                // mb: 0.5,
                                            }}
                                        >
                                            HAMARA CARE
                                        </Typography>

                                        {/* Store Name */}
                                        <Typography
                                            variant="subtitle1"
                                            component="h2"
                                            sx={{
                                                display: "inline-block", // 🔥 makes width fit content
                                                fontWeight: 600,
                                                color: "#efdd0c",
                                                backgroundColor: "#2a0000",
                                                borderRadius: 2,
                                                px: 3,
                                            }}
                                        >
                                            {selectedStore.name}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}

                            <form onSubmit={submitForm}>
                            
                                {/* Refer Through as Boxes */}
                                {!referValue && (
                                <Box
                                    mb={3}
                                    display="flex"
                                    flexDirection="column"
                                    gap={2}
                                    alignItems="center"
                                >
                                    {referOptions.map((option) => {
                                        const style = referColorOptions[option.name.toLowerCase()] || defaultStyle;

                                        return (
                                            <Box
                                            key={option.id}
                                            onClick={() => {
                                                fetchTodayCount()
                                                setReferValue(option)
                                            }} // 🔥 store full object
                                            sx={{
                                                width: "80%",
                                                maxWidth: 320,
                                                px: 3,
                                                py: 1.5,
                                                borderRadius: 2,
                                                cursor: "pointer",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                backgroundColor: style.bg,
                                                color: style.color,
                                                boxShadow: 1,
                                                transition: "all 0.2s ease",
                                                "&:hover": {
                                                opacity: 0.85,
                                                transform: "scale(1.02)",
                                                },
                                            }}
                                            >
                                            {option.name}
                                            </Box>
                                        );
                                    })}
                                </Box>
                                )}

                                {referValue && (
                                <Box mb={4}
                                    display="flex"
                                    justifyContent="center"   // 🔥 horizontal center
                                >
                                    <Box
                                    component="div"
                                    onClick={() => {
                                        setReferValue(null);
                                        setMobileValue("");
                                        setMobileError(false);
                                    }}
                                    sx={{
                                        width: "100%",
                                        // px: 3,
                                        py: 1.5,
                                        textAlign: "center",
                                        borderRadius: 2,
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        backgroundColor:
                                        referColorOptions[referValue.name.toLowerCase()]?.bg || defaultStyle.bg,
                                        color:
                                        referColorOptions[referValue.name.toLowerCase()]?.color || defaultStyle.color,
                                        boxShadow: 1,
                                    }}
                                    >
                                    {referValue.name}
                                    </Box>
                                </Box>
                                )}

                                {/* Name & Mobile */}
                                <Collapse in={!!referValue}>
                                    <Grid container spacing={2}>
                                        {/* Name */}
                                        <Grid size={{ xs: 12, sm: 6, md: 6 }} mb={1}>
                                            <TextField
                                            name="name"
                                            label="Full Name"
                                            fullWidth
                                            required
                                            className="input-bg"
                                            slotProps={{
                                                inputLabel: {
                                                sx: {
                                                    "& .MuiFormLabel-asterisk": {
                                                    color: "red",
                                                    fontWeight: "bold",
                                                    },
                                                },
                                                },
                                            }}
                                            />
                                        </Grid>
                                        {/* Mobile */}
                                        <Grid size={{ xs: 12, sm: 6, md: 6 }} mb={3}>
                                            <TextField
                                                name="mobile"
                                                label="Mobile Number"
                                                fullWidth
                                                required
                                                className="input-bg"
                                                type="tel"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                maxLength={10}
                                                value={mobileValue}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, "");

                                                    // enforce max 10 digits
                                                    if (value.length > 10) return;

                                                    setMobileValue(value);

                                                    // error if less than 10 digits (only after typing starts)
                                                    setMobileError(value.length > 0 && value.length < 10);

                                                    // if (autoFillWhatsApp && !whatsappValue) {
                                                    //     setWhatsappValue(value);
                                                    // }

                                                    // 🔥 Check only when exactly 10 digits
                                                    // if (value.length === 10) {
                                                    //     checkMobileExists(value);
                                                    // }
                                                }}
                                                error={mobileError}
                                                helperText={mobileError ? "Mobile number must be 10 digits" : ""}
                                                slotProps={{
                                                    inputLabel: {
                                                    sx: {
                                                        "& .MuiFormLabel-asterisk": {
                                                        color: "red",
                                                        fontWeight: "bold",
                                                        },
                                                    },
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Collapse>

                                {/* WhatsApp Number & Birthday */}
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }} mb={1} sx={{ display: 'none' }}>
                                        <TextField
                                        name="whatsapp"
                                        label="WhatsApp Number"
                                        fullWidth
                                        className="input-bg whatsapp"
                                        type="tel"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        maxLength={10}
                                        value={whatsappValue}
                                        onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");

                                                // enforce max 10 digits
                                                if (value.length > 10) return;

                                                setWhatsappValue(value)

                                                // error if less than 10 digits (only after typing starts)
                                                setWhatsappError(value.length > 0 && value.length < 10);
                                            }}
                                            error={whatsappError}
                                            helperText={whatsappError ? "Mobile number must be 10 digits" : ""}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={autoFillWhatsApp}
                                                    onChange={(e) => {
                                                        setAutoFillWhatsApp(e.target.checked);
                                                        if (e.target.checked && mobileValue && !whatsappValue) {
                                                            // fill WhatsApp immediately when checked
                                                            setWhatsappValue(mobileValue);
                                                        }
                                                    }}
                                                    size="small"
                                                />
                                            }
                                            label="Autofill WhatsApp"
                                            sx={{
                                                "& .MuiFormControlLabel-label": {
                                                fontSize: "0.8rem",   // smaller label text
                                                color: "#000",         // optional: change color
                                                },
                                                marginTop: 0,
                                                marginLeft: 0,
                                            }}
                                        />

                                    </Grid>

                                    <Grid size={{ xs: 12 }} sx={{ display: 'none' }}>
                                        <Grid container spacing={1}>
                                            {/* Birth Day */}
                                            <Grid size={{ xs: 6, sm: 6, md: 4 }} mb={2}>
                                                <TextField
                                                    select
                                                    label="Birth Day"
                                                    fullWidth
                                                    className="input-bg"
                                                    value={birthdayDay}
                                                    onChange={(e) => setBirthdayDay(e.target.value)}
                                                >
                                                    {[...Array(31)].map((_, i) => (
                                                    <MenuItem key={i + 1} value={i + 1}>
                                                        {i + 1}
                                                    </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>

                                            {/* Birth Month */}
                                            <Grid size={{ xs: 6, sm: 6, md: 4 }} mb={2}>
                                                <TextField
                                                    select
                                                    label="Birth Month"
                                                    fullWidth
                                                    className="input-bg"
                                                    value={birthdayMonth}
                                                    onChange={(e) => setBirthdayMonth(e.target.value)}
                                                >
                                                    {[
                                                    "Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"
                                                    ].map((month, i) => (
                                                    <MenuItem key={i + 1} value={i + 1}>
                                                        {month}
                                                    </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>

                                            {/* Marital Status */}
                                            <Grid size={{ xs: 12, sm: 12, md: 4 }} mb={2}>
                                            <Box>
                                            <TextField
                                                select
                                                label="Marital Status"
                                                fullWidth
                                                value={marital}
                                                onChange={(e) => setMarital(e.target.value)}
                                                className="input-bg"
                                            >
                                                <MenuItem value="single">Single</MenuItem>
                                                <MenuItem value="married">Married</MenuItem>
                                            </TextField>
                                            </Box>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Spouse Details */}
                                {marital === "married" && (
                                <Grid container spacing={2} mt={1}>
                                    <Grid size={{ xs: 12, sm: 12, md: 4 }} mb={2}>
                                        <TextField
                                            name="spouse"
                                            label="Spouse Name"
                                            fullWidth
                                            className="input-bg"
                                        />
                                    </Grid>

                                    {/* Anniversary Day */}
                                    <Grid size={{ xs: 6, sm: 6, md: 4 }} mb={2}>
                                        <TextField
                                            select
                                            label="Anniv Day"
                                            fullWidth
                                            className="input-bg"
                                            value={anniversaryDay}
                                            onChange={(e) => setAnniversaryDay(e.target.value)}
                                        >
                                            {[...Array(31)].map((_, i) => (
                                            <MenuItem key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    {/* Anniversary Month */}
                                    <Grid size={{ xs: 6, sm: 6, md: 4 }} mb={2}>
                                        <TextField
                                            select
                                            label="Anniv Month"
                                            fullWidth
                                            className="input-bg"
                                            value={anniversaryMonth}
                                            onChange={(e) => setAnniversaryMonth(e.target.value)}
                                        >
                                            {[
                                            "Jan","Feb","Mar","Apr","May","Jun",
                                            "Jul","Aug","Sep","Oct","Nov","Dec"
                                            ].map((month, i) => (
                                            <MenuItem key={i + 1} value={i + 1}>
                                                {month}
                                            </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                </Grid>

                                )}

                                {/* Location & Address */}
                                <Grid container spacing={2} mb={3} sx={{ display: 'none' }}>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <TextField
                                        name="location"
                                        label="Location"
                                        fullWidth
                                        className="input-bg"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <TextField
                                        name="address"
                                        label="Address"
                                        fullWidth
                                        className="input-bg"
                                        />
                                    </Grid>
                                </Grid>

                                {/* Simple JS Captcha */}
                                {referValue && (
                                    <Box className="captcha-box" mb={4}>
                                        <Grid container spacing={1} alignItems="center">
                                            
                                            {/* Captcha Number */}
                                            <Grid size={{ xs: 4 }}>
                                                <Box
                                                    sx={{
                                                        height: "40px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontWeight: "bold",
                                                        fontSize: "20px",
                                                        letterSpacing: "4px",
                                                        color: "#eef6cf",
                                                        backgroundImage: `url(${CaptchaBG})`,
                                                        borderRadius: "4px",
                                                        userSelect: "none",
                                                    }}
                                                >
                                                    {captcha.split("").map((d, i) => (
                                                        <span
                                                            key={i}
                                                            style={{
                                                                display: "inline-block",
                                                                transform: `rotate(${Math.random() * 10 - 14}deg)`,
                                                            }}
                                                        >
                                                            {d}
                                                        </span>
                                                    ))}
                                                </Box>
                                            </Grid>

                                            {/* Input */}
                                            <Grid size={{ xs: 6 }}>
                                                <TextField
                                                    label="Enter Captcha"
                                                    fullWidth
                                                    className="input-bg"
                                                    value={captchaValue}
                                                    inputRef={captchaInputRef}
                                                    onChange={(e) =>
                                                        setCaptchaValue(e.target.value.replace(/\D/g, ""))
                                                    }
                                                    inputProps={{
                                                        inputMode: "numeric",
                                                        pattern: "[0-9]*",
                                                        maxLength: 4,
                                                    }}
                                                />
                                            </Grid>

                                            {/* Refresh */}
                                            <Grid size={{ xs: 2 }}>
                                                <Button
                                                    size="small"
                                                    fullWidth
                                                    className="refresh-btn"
                                                    onClick={generateCaptcha}
                                                >
                                                    <RefreshIcon fontSize="small" />
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )}

                                {/* Submit */}
                                {referValue && (
                                    <>
                                        <Button
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            className="submit-btn"
                                        >
                                            Submit
                                        </Button>

                                        {/* 🔥 TODAY COUNT DISPLAY */}
                                        {todayCount !== null && (
                                            <Box
                                                mt={2}
                                                py={1.5}
                                                fontSize={13}
                                                textAlign="center"
                                                borderRadius={2}
                                                sx={{
                                                    // background: "linear-gradient(135deg, #1e3c72, #2a5298)",
                                                    color: "#2a0000",
                                                    fontWeight: "normal",
                                                    letterSpacing: "1px",
                                                    // boxShadow: 2,
                                                }}
                                            >
                                                Today’s Visitors: {todayCount}
                                            </Box>
                                        )}
                                    </>
                                )}


                            </form>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* PopUp Alerts */}
            <Dialog
            open={toast.open}
            onClose={() => setToast({ ...toast, open: false })}
            PaperProps={{
                sx: {
                borderRadius: 3,
                px: 3,
                py: 2,
                minWidth: 280,
                textAlign: "center",
                },
            }}
            >
            <DialogTitle
                sx={{
                fontWeight: "bold",
                color:
                    toast.severity === "success"
                    ? "green"
                    : toast.severity === "warning"
                    ? "#f57c00"
                    : "#d32f2f",
                }}
            >
                {
                toast.title ? toast.title : 
                    toast.severity === "success" ? "Success 🎉" : 
                        toast.severity === "warning" ? "Attention ⚠️" : "Error ❌"}
            </DialogTitle>

            <DialogContent>
                <Typography sx={{ fontSize: "1rem", fontWeight: 500 }}>
                {toast.message}
                </Typography>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                <Button
                variant="contained"
                onClick={() => {
                    setToast({ ...toast, open: false });

                    if (captchaError) {
                        setTimeout(() => {
                            captchaInputRef.current?.focus();
                            setCaptchaError(false);
                        }, 100);
                    }
                }}
                sx={{
                    borderRadius: 2,
                    px: 4,
                    backgroundColor:
                    toast.severity === "success"
                        ? "green"
                        : toast.severity === "warning"
                        ? "#f57c00"
                        : "#d32f2f",
                    "&:hover": {
                    opacity: 0.85,
                    },
                }}
                >
                OK
                </Button>
            </DialogActions>
            </Dialog>

            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                PaperProps={{
                    sx: {
                    backgroundColor: "#fef9e7e7",
                    border: "2px solid #2a0000",
                    borderRadius: 3,
                    minWidth: 320,
                    },
                }}
            >
                <DialogTitle
                    sx={{
                    color: "#2a0000",
                        fontWeight: 700,
                        borderBottom: "0px solid #efdd0c",
                        backgroundColor: "#fef9e7e7",
                    }}
                >
                    Mobile Number Already Exists
                </DialogTitle>

                <DialogActions
                    sx={{
                        backgroundColor: "#fef9e7e7",
                        borderTop: "0px solid #efdd0c",
                    }}
                >
                    <Button
                    onClick={() => setOpenDialog(false)}
                    sx={{
                        color: "#2a0000",
                        fontWeight: 600,
                        border: "1px solid #efdd0c",
                        "&:hover": {
                        backgroundColor: "#efdd0c",
                        color: "#2a0000",
                        },
                    }}
                    >
                    Close
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
}

export default CustomerForm;


/*

 <DialogContent
    dividers
    sx={{
        color: "#2a0000",
        backgroundColor: "#fef9e7e7",
    }}
>
    <Typography sx={{ mb: 1 }}>
    <b>Name:</b> {existingUser?.name}
    </Typography>
    <Typography sx={{ mb: 1 }}>
    <b>Mobile:</b> {existingUser?.mobile}
    </Typography>
    <Typography sx={{ mb: 1 }}>
    <b>Referred By:</b> {existingUser?.refer_through}
    </Typography>
        <Typography sx={{ mb: 1 }}>
    <b>Store:</b> {existingUser?.store}
    </Typography>
        <Typography>
    <b>Date & Time:</b> {existingUser?.datetime}
    </Typography>
</DialogContent>

*/

/*

<Box size={{ xs: 12, sm: 12, md: 12 }} mb={3}>
    <TextField
        select
        name="refer"
        label="Referred By"
        fullWidth
        required
        className="input-bg"
        value={referValue || ""}
        onChange={(e) => setReferValue(e.target.value)}
        slotProps={{
            inputLabel: {
                sx: {
                    "& .MuiFormLabel-asterisk": {
                    color: "red",
                    fontWeight: "bold",
                    },
                },
            },
            select: {
                MenuProps: {
                    PaperProps: {
                        sx: { maxHeight: 200 },
                    },
                },
            },
        }}
    >
        <MenuItem value="" disabled>
            Select option
        </MenuItem>

        {referOptions.map((option, index) => (
        <MenuItem 
            key={option.id} 
            value={option.id}
            sx={{
                color: getDistinctColor(index),
                fontWeight: 700,
            }}
        >
            {option.name}
        </MenuItem>
        ))}
    </TextField>
</Box>

*/


/*

<Box className="captcha-box" mb={4}>
{captcha.image_url && (
    <Grid container spacing={1} alignItems="center">
        <Grid size={{ xs: 4 }}>
            <img
            src={captcha.image_url}
            alt="captcha"
            style={{ width: "100%", height: "40px", objectFit: "contain" }}
            />
        </Grid>

        <Grid size={{ xs: 6 }}>
            <TextField
                label="Captcha"
                fullWidth
                className="input-bg"
                value={captchaValue}
                onChange={(e) => setCaptchaValue(e.target.value.toUpperCase())}
            />
        </Grid>

        <Grid size={{ xs: 2 }}>
            <Button
            size="small"
            fullWidth
            className="refresh-btn"
            onClick={fetchCaptcha}
            >
            <RefreshIcon fontSize="small" />
            </Button>
        </Grid>
    </Grid>
)}
</Box> 

*/

/* 

<StoreSelector
    value={selectedStore}
    onChange={(store) => setSelectedStore(store)}
/> 

*/